import CONFIG from '../../../config'

import AppHeader from '../../components/app-header'
import AppFooter from '../../components/app-footer'

import AppButton from '../../components/app-button'
import AppIcon from '../../components/app-icon'
import AppTranslate from '../../components/app-translate'

export default {
    name: 'app-page',

    components: {
        AppHeader,
        AppFooter,

        AppButton,
        AppIcon,
        AppTranslate
    },

    props: {
        taxonomies: { type: Object },
        content: { type: Object },
        params: { type: Object },
        isFirstLoading: { type: Boolean, default: true },
        isFirstLoaded: { type: Boolean, default: false },
        routingStep: { type: Number, default: 0 }
    },

    watch: {
        ready() {
            if (this.ready) {
                this.eventHub.$emit('page:ready', this.ready)
            }
        }
    },

    data() {
        return {
            CONFIG,

            meta: null,

            ready: false
        }
    },

    created() {
        this.eventHub.$emit('page:scroll-to', 0)
        this.meta = this.$route.meta

        this.eventHub.$on('window:resize', this.resize)
    },

    mounted() {
        this.eventHub.$emit('page:scroll-to', 0)
        setTimeout(this.resize, 100)

        setTimeout(() => {
            document.body.classList.remove('u-overlow-h')
        }, 1500)
        
        // Fake loading
        this.eventHub.$emit('app-loader:start-loading-asset')
        window.setTimeout(() => {
            this.eventHub.$emit('app-loader:end-loading-asset')
        }, 30)
    },

    destroyed() {
        this.eventHub.$off('window:resize', this.resize)
    },

    methods: {
        resize() {
            this.eventHub.$emit('page:set-height', this.$el.offsetHeight)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/app-page/index.js